import { useAuth } from '../contexts/AuthContext';

export const useRole = () => {
  const { user } = useAuth();
  return {
    isAdmin: user?.role === 'admin',
  };
};

export const useTeamRole = (team) => {
  const { user } = useAuth();
  if (!team || !user) return null;
  if (team.owner_id === user.id) return 'owner';
  const member = team.members?.find(m => m.user_id === user.id);
  return member?.role ?? null;
};

export const canEditInTeam = (role) =>
  ['owner', 'admin', 'team_manager'].includes(role);

export const canCreateInTeam = (role) =>
  ['owner', 'admin', 'team_manager', 'member'].includes(role);

export const canCommentInTeam = (role) =>
  ['owner', 'admin', 'team_manager', 'member', 'client'].includes(role);
